// src/redux/TradeApi.js
import { makePayment ,getPaymentStatus} from "../components/constant/Api";
import { myApi } from "./api";

export const PaymentCryptoApi = myApi.injectEndpoints({
  endpoints: (builder) => ({
    makeCryptoPayment: builder.mutation({
      query: (payload) => ({
        url: makePayment,
        method: "POST",
        body: payload,
      }),
      transformResponse: (response) => {
        return response.status ? response : null;
      },
    }),
 
    getPaymentStatus: builder.query({
      query: (billingId) => getPaymentStatus(billingId),
      transformResponse: (response) => response,
    }),
  }),
});

export const { useMakeCryptoPaymentMutation,useGetPaymentStatusQuery,useLazyGetPaymentStatusQuery } = PaymentCryptoApi;
